import React, { useState, useContext } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { AgendaContext } from '../../../contexts/AgendaContext';
// Mui components
import { Box, Typography } from '@mui/material';
// Components
import SelectorEspecialidades from './SelectorEspecialidades';
import FooterSolicitarModificacion from './FooterSolicitarModificacion';
// Icons
import IconClose from '../../../utils/images/icon_close.svg';
import IconCircleInformation from '../../../utils/images/icon_circle-information.svg';
// Modals
import ModalEnviarSolicitudModificacion from '../Modals/ModalEnviarSolicitudModificacion';
import ModalErrorEnviarSolicitud from '../Modals/ModalErrorEnviarSolicitud.jsx';

export default function SolicitarModificacion() {
  const {
    prestadoresOsde,
    consultorioDetail,
    postSolicitudModificar,
    setSolicitudProps,
    prestadorSesion
  } = useContext(AgendaContext);


  const navigate = useNavigate();

  const { consultorioId } = useParams();
  const [cambiosRealizados, setCambiosRealizados] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [succesSolicitud, SetSuccesSolicitud] = useState(false);
  const [openModalError, setOpenModalError] = useState(false);

  const [openModalEnviarModificacion, SetOpenModalEnviarModificacion] = useState(false);

  const prestadorEncontrado = prestadorSesion.find(prestador => prestador.consultorios.some(consultorio => consultorio.consultorioOsde.some(osde => osde.consultorioId === consultorioId)));

  const handleOpenModalEnviarModificacion = () => {
    SetOpenModalEnviarModificacion(!openModalEnviarModificacion);
  };

  const especialidades = prestadoresOsde.consultorioOsde
    .find((c) => {
      return consultorioDetail.consultorioOsde[0].consultorioId == c.consultorioId;
    })
    .especializacion.map((esp) => {
      esp.solicitada = consultorioDetail.especialidades.some((e) => e.codigoOsde == esp.codigoOsde);
      return esp;
    });

  const [selectedEspecializaciones, setSelectedEspecializaciones] = useState(
    [...especialidades] || []
  );

  const handleClick = async () => {
    setCambiosRealizados(false);
    setIsLoading(true);
    const bodyObject = {
      cuit: prestadoresOsde?.cuit,
      proveedor: consultorioDetail?.proveedor,
      proveedorId: consultorioDetail?.idProveedor,
      tipoSolicitud: 'MODIFICAR_CONSULTORIO',
      descripcionSolicitud: 'Modificacion de consultorio',
      consultorioExterno: consultorioDetail?.consultorioExterno[0]?.consultorioId,
      consultorioOsde: consultorioDetail?.consultorioOsde[0]?.consultorioId,
      especializacion: selectedEspecializaciones,
      nombre: prestadorEncontrado?.nombre,
      direccionOsde: consultorioDetail?.consultorioOsde[0]?.direccion,
      filial: consultorioDetail?.consultorioOsde[0]?.filial,
      status: 'PENDIENTE',
      direccionExterno: consultorioDetail?.consultorioExterno[0]?.direccion,
      datosContacto: consultorioDetail?.datosContacto,
      icPrestador: prestadorEncontrado.icPrestador
    };
    setSolicitudProps(bodyObject);
    try {
      await postSolicitudModificar(bodyObject);
      SetSuccesSolicitud(true);
      setOpenModalError(false);
    } catch (error) {
      SetSuccesSolicitud(false);
      setOpenModalError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100vh',
        alignItems: 'center',
        justifyContent: 'space-between'
      }}>
      <Box
        sx={{
          display: 'flex',
          width: '530px',
          marginTop: 'calc(3rem + 76px)',
          marginLeft: '4rem',
          height: '568px',
          flexDirection: 'column',
          gap: '2rem'
        }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '1rem'
          }}>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              width: '100%',
              alignItems: 'center'
            }}>
            <Box
              sx={{
                display: 'flex',
                cursor: 'pointer',
                width: '50px',
                height: '100%',
                justifyContent: 'flex-end'
              }}
              onClick={() =>
                navigate(
                  `/prestador/misConsultorios/${consultorioDetail.consultorioOsde[0].consultorioId}`
                )
              }>
              <Box
                component="img"
                sx={{
                  width: '24px',
                  height: '24px',
                  display: 'flex',
                  cursor: 'pointer',
                  justifyContent: 'flex-end'
                }}
                alt="img not found"
                src={IconClose}
                onClick={() =>
                  navigate(
                    `/prestador/misConsultorios/${consultorioDetail.consultorioOsde[0].consultorioId}`
                  )
                }
              />
            </Box>
          </Box>
          <Box
            sx={{
              display: 'flex',
              width: '100%',
              justifyContent: 'flex-start'
            }}>
            <Typography variant="h2">Solicitud de modificación</Typography>
          </Box>
        </Box>
        <Box sx={{ display: 'flex', gap: '1.5rem', width: '100%', flexDirection: 'column' }}>
          <Box sx={{ display: 'flex', gap: '0.5rem', width: '100%', flexDirection: 'column' }}>
            <Typography variant="h4">Especialidades</Typography>
            <Typography variant="h5">
              Seleccioná las especialidades cuyos turnos querés conectar con la agenda de OSDE.
            </Typography>
          </Box>

          <Box sx={{ display: 'flex', gap: '0.5rem' }}>
            <Box
              component="img"
              sx={{ width: '16px', height: '16px' }}
              alt="img not found"
              src={IconCircleInformation}
            />
            <Typography variant="bodyS">
              Siempre deberás tener al menos una seleccionada.
            </Typography>
          </Box>

          <SelectorEspecialidades
            selectedEspecializaciones={selectedEspecializaciones}
            setSelectedEspecializaciones={setSelectedEspecializaciones}
            especialidades={especialidades}
            setCambiosRealizados={setCambiosRealizados}
          />
        </Box>
      </Box>
      <ModalEnviarSolicitudModificacion
        isLoading={isLoading}
        especialidadesDefault={[...especialidades]}
        selectedEspecializaciones={selectedEspecializaciones}
        modalIsVisible={openModalEnviarModificacion}
        handleClose={handleOpenModalEnviarModificacion}
        handleClick={handleClick}
        succesSolicitud={succesSolicitud}
        openModalError={openModalError}
      />

      <ModalErrorEnviarSolicitud open={openModalError} />

      <FooterSolicitarModificacion
        selectedEspecializaciones={selectedEspecializaciones}
        cambiosRealizados={cambiosRealizados}
        handleOpenModalEnviarModificacion={handleOpenModalEnviarModificacion}
      />
    </Box>
  );
}
